module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0078.430b843b.jpg";